import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ReturnOrder",
    component: () => (__SERVER__ ? require("./return-order-view") : import("./return-order-view"))
});

export default definition;
